// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-affix.k-fixed{position:relative;z-index:9}", "",{"version":3,"sources":["webpack://node_modules/kpc-react/@stylus/components/affix/index.styl"],"names":[],"mappings":"AAEA,iBACI,iBAAS,CACT,SAAQ","sourcesContent":["@require('./variables.styl')\n\n.k-affix.k-fixed\n    position relative\n    z-index $affix-z-index\n\n\nrequireTheme('affix')\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
